import { render, staticRenderFns } from "./menu_finger.vue?vue&type=template&id=b9104f82&"
import script from "./menu_finger.vue?vue&type=script&lang=js&"
export * from "./menu_finger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports